var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPerson = function SvgIconPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-person_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-person_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M10 10a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 7 7c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 10 4c.833 0 1.542.292 2.125.875S13 6.167 13 7s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 10 10Zm-6 4.5V14c0-.32.087-.621.26-.906a2.22 2.22 0 0 1 .72-.719 10.242 10.242 0 0 1 2.422-1.02 9.662 9.662 0 0 1 5.192 0c.854.235 1.663.576 2.427 1.02.305.18.545.417.719.708.173.292.26.598.26.917v.5c0 .412-.147.766-.44 1.06a1.45 1.45 0 0 1-1.06.44H5.493c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 0 1 4 14.5Zm1.5 0h9V14a.33.33 0 0 0-.063-.196.422.422 0 0 0-.166-.137 7.812 7.812 0 0 0-2.042-.875A8.535 8.535 0 0 0 10 12.5c-.764 0-1.507.097-2.23.292a7.812 7.812 0 0 0-2.04.875 1.09 1.09 0 0 0-.168.16A.268.268 0 0 0 5.5 14v.5Zm4.504-6c.414 0 .767-.147 1.059-.442.291-.295.437-.649.437-1.062 0-.414-.147-.767-.442-1.059A1.456 1.456 0 0 0 9.996 5.5c-.414 0-.767.147-1.059.442A1.456 1.456 0 0 0 8.5 7.004c0 .414.147.767.442 1.059.295.291.649.437 1.062.437Z"
  }))));
};
export default SvgIconPerson;